import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OccupationGraphqlApi } from './core/api/occupation-graphql.api';
import { HIGH_SCHOOL_SALARY_DOCUMENT } from './graphql/high-school-salary.graphql';
import { HighSchoolSalary } from './models/high-school-salary.model';

@Injectable()
export class HighSchoolSalaryService {
  public constructor(private occupationGraphql: OccupationGraphqlApi) {}

  public getHighSchoolSalary(): Observable<HighSchoolSalary> {
    return this.occupationGraphql
      .query<{ highSchoolCipCodeSalaries: HighSchoolSalary }>(HIGH_SCHOOL_SALARY_DOCUMENT, {})
      .pipe(map(data => data.highSchoolCipCodeSalaries));
  }
}
